import { useState, useEffect } from "react";
import { API_URLS,  } from "./config";
import axios from 'axios';
interface NavbarLabels {
  title: string;
  rulesSetTitle: string;
  faqTitle: string;
  myAnalyses: string;
  newAnalyse: string;
}
declare global {
  interface Window {
    allTranslatedLabels ?: [];
  }
}
export function AppLabelService(langage: any) {
  const [allLabels, setAllLabels] = useState<any | null>(null);
  const [loading, setLoading] = useState<Boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const domain = window.location.hostname;

  useEffect(() => {
    const fetchAppLabels = async () => {
      try {
        const response = await axios.get(API_URLS.APP_LABEL, {
          params: {
            locale: langage,
            populate: "*",
            filters:{
              frontend_types: {
                  hostname: {
                    $eq: domain,
                  },
                },
              },
          }
        });

        // check response
        if (response.status != 200) {
          throw new Error("Failed to fetch Navbar data");
        }

        const json = response.data;
        let allLabels: any = {};
        json.data?.forEach((item: any)=>{
          if (!allLabels?.[item?.locale]) {
            allLabels[item?.locale] = {};
          }
          if (!allLabels?.[item?.localizations?.[0]?.locale]) {
            allLabels[item?.localizations?.[0]?.locale] = {};
          }
          allLabels[item?.locale][item?.keyname] = item?.value;
          if(item?.localizations && item?.localizations?.[0] && item?.localizations?.[0]?.keyname === item?.keyname) {
            allLabels[item?.localizations?.[0]?.locale][item.keyname] = item?.localizations?.[0]?.value;
          }
        })
        window.allTranslatedLabels  = allLabels;
        setAllLabels(allLabels);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchAppLabels();
  }, [langage]);

  return { allLabels, loading, error };
}
